<div
    [id]="id"
    *ngIf="entityInternal"
    class="agpr-targetingResults-cardWrapper agpr-contextMenu-parent"
    [ngClass]="{
        'agpr-matched-contact-view': cardMode === cardModes.editorMatchedContact,
        'agpr-targetingResults-cardWrapper-focused': selectedContactId === entityInternal.id
    }"
>
    <div
        role="group"
        class="agpr-targetingResults-card card"
        [ngClass]="{'agpr-targetingResults-card--expanded': expanded}"
        (agprClickUnless)="cardFocused()"
        [agprClickUnlessSelectors]="['a', 'agpr-checkbox']"
        [attr.aria-label]="'Discover.universal.contactCard.label' | localize: {first: entityInternal.firstName, last: entityInternal.lastName}"
        (keydown)="onKeydown($event)"
    >
        <div class="agpr-targetingResults-card-grid">
            <div class="agpr-targetingResults-card-left">
                <div
                    *ngIf="cardMode !== cardModes.editorMatchedContact"
                    class="agpr-targetingResults-card-checkbox"
                >
                    <agpr-checkbox
                        [id]="id + '_selectCheckbox'"
                        [disabled]="disableSelection"
                        [value]="entityInternal"
                        [hiddenLabel]="entityInternal.firstName + ' ' + entityInternal.lastName"
                        [initiallyFocusable]="initiallyFocusable"
                        [(ngModel)]="selectedResults"
                        (onChange)="checkboxClick()"
                    ></agpr-checkbox>
                    <div
                        *ngIf="selectedContactId === entityInternal.id"
                        class="agpr-targetingResults-card-selectedBar"
                    ></div>
                </div>

                <div class="agpr-targetingResults-card-thumbnail">
                    <img
                        class="agpr-targetingResults-card-thumbnail-img"
                        alt=""
                        [agprImageSrc]="entityInternal?.avatarUrl | twitterAvatarSize:twitterAvatarSizes.bigger"
                        [agprDefaultImage]="imageDefault.SMALL_CONTACT"
                    />
                    <span
                        *ngIf="listMemberships.length > 0 && listMemberships.length === workingLists.length"
                        role="img"
                        class="fa-solid fa-check agpr-targetingResults-card-thumbnail-checkmark"
                        [agprTooltip]="listMembershipTooltip"
                        [escape]="false"
                        [initiallyFocusable]="initiallyFocusable"
                    ></span>
                    <span
                        *ngIf="listMemberships.length > 0 && listMemberships.length !== workingLists.length"
                        class="agpr-targetingResults-card-thumbnail-number"
                        [agprTooltip]="listMembershipTooltip"
                        [escape]="false"
                        [initiallyFocusable]="initiallyFocusable"
                    >
                        {{ listMemberships.length }}
                    </span>

                    @if(distMemberships.length > 0 && distMemberships.length === workingDists.length) {
                        <span
                            role="img"
                            class="fa-regular fa-duotone fa-check agpr-targetingResults-card-thumbnail-checkmark"
                            [agprTooltip]="distMembershipTooltip"
                            [escape]="false"
                            [initiallyFocusable]="initiallyFocusable"
                        ></span>
                    }
                    @if(distMemberships.length > 0 && distMemberships.length !== workingDists.length) {
                        <span
                            class="agpr-targetingResults-card-thumbnail-number"
                            [agprTooltip]="distMembershipTooltip"
                            [escape]="false"
                            [initiallyFocusable]="initiallyFocusable"
                        >
                            {{ distMemberships.length }}
                        </span>
                    }
                </div>
                <div class="agpr-targetingResults-card-description-container">
                    <div class="agpr-targetingResults-card-description">
                        <div class="agpr-targetingResults-card-description-profile">
                            <a
                                class="agpr-targetingResults-card-description-profile-name"
                                href="#contact-profile"
                                [id]="entityInternal.id + '_contact_profile'"
                                [agprInitiallyFocusable]="initiallyFocusable"
                                (click)="focusContact($event)"
                                [agprTooltip]="'Discover.universal.contactNameLink.tooltip'"
                                tooltipPosition="top"
                            >
                                {{entityInternal.firstName}} {{entityInternal.lastName}}
                            </a>
                            <span
                                role="img"
                                class="fa-solid fa-user agpr-targetingResults-card-description-profile-icon"
                                [attr.aria-label]="'Discover.universal.contactLinkIcon'"
                            ></span>
                        </div>
                        <div
                            *ngIf="entityInternal.selectedEmployment?.jobTitle"
                            class="agpr-targetingResults-card-description-jobtitle"
                        >
                            <span
                                [pTooltip]="entityInternal.selectedEmployment.jobTitle"
                                tooltipPosition="top"
                            >
                                {{entityInternal.selectedEmployment.jobTitle}}
                            </span>
                        </div>
                        <div
                            *ngIf="entityInternal.selectedEmployment?.outlet?.name"
                            class="agpr-targetingResults-card-description-outlet"
                        >
                            <!-- do not change the indent, otherwise, it would display an extra space with underline when hover -->
                            <a
                                *ngIf="entityInternal.selectedEmployment?.outlet?.id"
                                class="agpr-targetingResults-card-description-outlet--leftAlign"
                                href="#out-profile"
                                [id]="entityInternal.id + '_outlet_profile'"
                                [agprInitiallyFocusable]="initiallyFocusable"
                                [agprTooltip]="'Discover.universal.outletLink.tooltip'"
                                tooltipPosition="top"
                                (click)="focusOutlet($event)"
                            >{{ entityInternal.selectedEmployment.outlet.name | localize}}
                            </a>
                            @if (entityInternal.selectedEmployment.outlet.isAiReference) {
                                <span
                                    role="img"
                                    class="agpr-targetingResults-card-badges fa-kit-duotone fa-agpr-ai-badge"
                                    agprTooltip="Discover.badges.tooltips.outlet.aiReferenceLeader"
                                ></span>
                            }

                            <span
                                *ngIf="entityInternal.selectedEmployment?.outlet?.id"
                                role="img"
                                class="fa-kit fa-agpr-outlet-solid agpr-targetingResults-card-description-outlet-icon"
                                [attr.aria-label]="'Discover.universal.outletLinkIcon'"
                            ></span>
                            <p *ngIf="!entityInternal.selectedEmployment?.outlet?.id"> {{ entityInternal.selectedEmployment.outlet.name }} </p>
                        </div>
                    </div>

                    <div class="agpr-targetingResults-card-details-badges">
                        <span
                            *ngFor="let badge of entityInternal.badges"
                            role="img"
                            class="agpr-targetingResults-card-badges"
                            [agprTooltip]="badge.tooltip"
                            tooltipPosition="top"
                            [initiallyFocusable]="initiallyFocusable"
                        >
                            <span class="{{ badge.iconClass }}" aria-hidden="true"></span>
                        </span>
                    </div>
                </div>
            </div>

            <div class="agpr-targetingResults-card-divider"></div>

            <div
                *ngIf="cardMode !== cardModes.editorMatchedContact"
                class="agpr-targetingResults-card-details-container agpr-targetingResults-card-right"
            >
                <div class="agpr-targetingResults-card-details">
                    <div class="agpr-targetingResults-card-details-field">
                        <div
                            *ngIf="entityInternal.locationString"
                            class="agpr-targetingResults-card-details-location"
                        >
                            <agpr-meta-data
                                [id]="id"
                                [icon]="'fa-solid fa-location-dot'"
                                [value]="entityInternal.locationString"
                                [tooltip]="entityInternal.locationString"
                                [initiallyFocusable]="initiallyFocusable">
                            </agpr-meta-data>
                        </div>
                        <div
                            *ngIf="!entityInternal.locationString"
                            class="agpr-targetingResults-card-details-location"
                        >
                            <agpr-meta-data
                                [id]="id"
                                [icon]="'fa-solid fa-location-dot'"
                                [value]="'Discover.universal.unknownLocation'"
                                [tooltip]="'Mention.details.location'"
                                [initiallyFocusable]="initiallyFocusable">
                            </agpr-meta-data>
                        </div>
                    </div>

                    <div
                        class="agpr-targetingResults-card-details-field"
                        *ngIf="reachValue"
                    >
                        <agpr-meta-data
                            [id]="id"
                            [type]="attributeTypes.audienceReach"
                            [icon]="reachIcon"
                            [value]="reachValue"
                            [isSimilarWeb]="isReachValueFromSimilarWeb"
                            [tooltip]="reachUnit"
                            [initiallyFocusable]="initiallyFocusable"
                        ></agpr-meta-data>
                    </div>
                </div>

                <div class="agpr-targetingResults-card-details-toggle">
                    <agpr-button
                        *ngIf="entityInternal.numberOfEmployments > 1 || entityInternal.hasActiveNotice"
                        [id]="id + '_toggleExpansion'"
                        class="agpr-targetingResults-card-toggleEmploymentButton agpr-expandToggle"
                        [style]="buttonTypes.icon"
                        [icon]="expanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                        [expanded]="expanded"
                        ariaLabel="Discover.targeting.tooltips.expandEmployment"
                        [agprTooltip]="expanded
                            ? entityInternal.hasActiveNotice
                                ? 'Discover.resultCard.activeNotices.selectNewEmployment.tooltip'
                                : 'Discover.distribution.statistics.lessDetails'
                            : 'Discover.distribution.statistics.moreDetails'"
                        tooltipPosition="top"
                        [initiallyFocusable]="initiallyFocusable"
                        [disabled]="entityInternal.hasActiveNotice"
                        (click)="toggleExpansion()"
                    ></agpr-button>
                </div>
            </div>
        </div>
    </div>
    <div
        *ngIf="entityInternal.numberOfEmployments > 1 || entityInternal.hasActiveNotice"
        class="agpr-targetingResults-card-subcardGroup"
        [attr.aria-label]="'Discover.entityProfile.moreEmployments' | localize"
        [@showMoreContent]="animationState"
    >
        <ng-container>
            <div
                *ngIf="entityInternal.hasActiveNotice"
                class="agpr-targetingResults-card-activeNotice"
            >
                <agpr-message [severity]="messageSeverity.warning">
                    {{ 'Discover.resultCard.activeNotices.selectNewEmployment' | localize }}
                </agpr-message>
            </div>
            <div
                *ngFor="let employment of entityInternal.loadedEmployments; let i = index; let last = last"
                class="agpr-targetingResults-card agpr-targetingResults-card-subcard"
            >
                <div class="agpr-targetingResults-card-left">
                    <div
                        class="agpr-targetingResults-card-subcard-description"
                        [ngClass]="{'agpr-targetingResults-card-subcard-description-last': last}"
                    >
                        <agpr-radio
                            [id]="id + '_selectedEmployment_' + i"
                            [value]="employment"
                            name="{{entityInternal.id}}_contact_employment"
                            [(ngModel)]="entityInternal.selectedEmployment"
                            (ngModelChange)="selectedEmploymentChanged()"
                            [hiddenLabel]="employment.outlet?.name"
                        ></agpr-radio>
                        <div class="agpr-targetingResults-card-thumbnail agpr-targetingResults-card-subcard-thumbnail">
                            <img
                                class="agpr-targetingResults-card-subcard-thumbnail-img"
                                [agprImageSrc]="employment.outlet?.avatarUrl"
                                alt=""
                                [agprDefaultImage]="imageDefault.SMALL_OUTLET"
                            />
                        </div>

                        <div
                            class="agpr-targetingResults-card-description-container agpr-targetingResults-card-subcard-description-container"
                            [ngClass]="{'agpr-targetingResults-card-subcard-description-container--last': last}"
                        >
                            <div class="agpr-targetingResults-card-description">
                                <div class="agpr-targetingResults-card-subcard-name">{{employment.outlet?.name}}</div>
                                <div class="agpr-targetingResults-card-description-jobtitle agpr-targetingResults-card-subcard-description-jobTitle">{{employment.jobTitle}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="agpr-targetingResults-card-right">
                    <div
                        class="agpr-targetingResults-card-subcard-details"
                        [ngClass]="{'agpr-targetingResults-card-subcard-details-last': last}"
                    >
                        @if (employment.outlet?.circulations) {
                            @for (item of employment.outlet.circulations; track item.circulationType.enumValue) {
                                @if (item.circulationType.enumValue === sortCirculationType) {
                                    <div class="agpr-targetingResults-card-subcard-details-circulation">
                                        {{ item.value | number }}
                                    </div>
                                }
                            }
                        }
                        <div>{{employment.outlet?.geography?.displayString}}</div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="agpr-contextMenu bottom right">
        <agpr-button
            *ngIf="cardMode === cardModes.editorMatchedContact"
            [id]="id + '.expand'"
            [icon]="'fa-regular fa-arrow-up-right-and-arrow-down-left-from-center'"
            (click)="expandClicked()"
            tooltip="Discover.entityProfile.expand"
            tooltipPosition="top"
            [initiallyFocusable]="initiallyFocusable"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
        <agpr-button
            *ngIf="entityInternal.isPrivate"
            [id]="id + '.editContact'"
            [icon]="'fa-regular fa-duotone fa-pen'"
            (click)="editContact(entityInternal)"
            tooltip="Discover.targeting.actions.editContact"
            tooltipPosition="top"
            [initiallyFocusable]="initiallyFocusable"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
        <agpr-button
            *ngIf="entityInternal.isPrivate"
            [id]="id + '.deleteContact'"
            [icon]="'fa-regular fa-duotone fa-trash-can'"
            (click)="deleteContact(entityInternal)"
            tooltip="Discover.targeting.actions.deleteContact"
            tooltipPosition="top"
            [initiallyFocusable]="initiallyFocusable"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
        <ng-container *ngIf="contextMenuTemplate">
            <ng-container
                *ngTemplateOutlet="
                    contextMenuTemplate;
                    context: {
                        selectedResult: entityInternal
                    }"
            ></ng-container>
        </ng-container>
        @if ((dataConnectionService.hasEmailAccountProvision$ | async) && (dataConnectionService.hasEmailAccountConnectors$ | async)) {
            <agpr-button
                [id]="id + '_composeEmail'"
                [icon]="'fa-regular fa-duotone fa-pen-swirl'"
                (click)="composeEmail()"
                tooltip="Discover.entityProfile.composeEmail"
                tooltipPosition="top"
                [style]="buttonTypes.contextMenu"
                [initiallyFocusable]="initiallyFocusable"
            ></agpr-button>
        }
        @if (addToType === targetingAddToTypes.LIST) {
            <agpr-button
                [id]="id + '.manageList'"
                [icon]="'fa-regular fa-duotone fa-gear'"
                (click)="openManageListDialog(entityInternal)"
                tooltip="Discover.targeting.actions.manageLists"
                tooltipPosition="top"
                [initiallyFocusable]="initiallyFocusable"
                [style]="buttonTypes.contextMenu"
            ></agpr-button>
        }
        @if (addToType === targetingAddToTypes.DISTRIBUTION) {
            <agpr-button
                [id]="id + '.manageDist'"
                [icon]="'fa-regular fa-duotone fa-gear'"
                tooltipPosition="top"
                (click)="openManageDistDialog(entityInternal)"
                tooltip="Discover.targeting.actions.manageDists"
                [initiallyFocusable]="initiallyFocusable"
                [style]="buttonTypes.contextMenu"
            ></agpr-button>
        }
    </div>
</div>
